import { Props as ILicensePlateInputBaseProps, LicensePlateInputBase } from '@carsys/ui/src/LicensePlate/LicensePlateInputBase'
import { TextField } from '@carsys/form/src/TextField'
import { useField } from 'formik'
import { IProductWithState } from '@cbgms/api'
import { useLicensePlateVariant } from '@carsys/form/src/formbuilder/hooks/use-license-plate-variant'

interface IProps
  extends Omit<React.ComponentProps<typeof TextField>, 'children' | 'variant' | 'size'>,
    Omit<ILicensePlateInputBaseProps, 'value' | 'variant'> {
  product: IProductWithState | null
  country: string
}

export const LicensePlateWithTextField: React.FC<IProps> = props => {
  const { size, children, product, ...textFieldProps } = props
  const variant = useLicensePlateVariant(product)
  const [input] = useField<string>({ name: props.name, validate: props.validate })

  return (
    <>
      <TextField {...textFieldProps} helperText=' ' />
      <LicensePlateInputBase variant={variant} country={props.country} value={input.value} />
    </>
  )
}
